import * as moment from 'moment';
import { AcOnlinetestModel } from 'projects/core/src/lib/models/ac-onlinetest.model';

export class RunnerOnlinetestModel extends AcOnlinetestModel {

  visible_at: any; // tslint:disable-line: variable-name
  onlinetest_id: number; // tslint:disable-line: variable-name

  public get visible(): boolean {
    return moment().isAfter(this.visible_at);
  }

}
